/**
 * @deprecated This file is kept for backward compatibility.
 * Please use '../utils/auth' for new code.
 */
import {
  getCurrentUser,
  isAuthenticated as checkAuthenticated,
  canDeleteIdea as canDelete
} from './auth';
import type { User } from '../types/shared.types';

interface ResourceWithOwner {
  owner_id?: number | string;
}

interface UserLike {
  id: number | string;
  role?: string;
}

// Auth helper utilities - legacy wrappers
export const ensureUserData = (): Partial<User> => {
  return getCurrentUser() || {};
};

export const isAuthenticated = (): boolean => {
  return checkAuthenticated();
};

export const canDeleteIdea = (idea: ResourceWithOwner | null, user: UserLike | null): boolean => {
  return canDelete(idea, user as Parameters<typeof canDelete>[1]);
};
